import { Navigate, useParams } from 'react-router'
import { withQuery } from '@/lib/query-params'
import { featureEnabled } from '@/config/features'
import type { StepId } from './flow'
import { stepPath } from './flow'
import { Cara } from './steps/Cara'
import { Datos } from './steps/Datos'
import { DocumentoTipo } from './steps/DocumentoTipo'
import { Documento } from './steps/Documento'
import { Firma } from './steps/Firma'
import { Invitar } from './steps/Invitar'
import { Ley } from './steps/Ley'
import { Listo } from './steps/Listo'
import { Llegada } from './steps/Llegada'
import { Metodo } from './steps/Metodo'
import { Revision } from './steps/Revision'

const STEPS: Partial<Record<StepId, () => React.ReactNode>> = {
  '1b': () => <Invitar />,
  '1c': () => <Metodo />,
  '2': () => <Datos />,
  '2c': () => <DocumentoTipo />,
  '3': () => <Documento />,
  '3b': () => <Revision />,
  '4': () => <Cara />,
  '5': () => <Ley />,
  '6': () => <Llegada />,
  '7': () => <Firma />,
  '8': () => <Listo />,
}

/** /checkin/paso/:paso con los ids de paso del bundle (1b, 2, 3, 3b… 8) y 1c (método, D33). */
export function CheckinStep() {
  const { paso } = useParams()
  if (paso === '1b' && !featureEnabled('invitados')) return <Navigate to={withQuery(stepPath('1'), window.location.search)} replace />
  const render = STEPS[paso as StepId]
  if (!render) return <Navigate to={withQuery(stepPath('1'), window.location.search)} replace />
  return <>{render()}</>
}

export { CheckinFlow } from './CheckinFlow'
export { Ocupantes } from './steps/Ocupantes'
export { Completar } from './steps/Completar'
